import styled from 'styled-components';

const ControlPanel = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    padding: 4px;
    grid-column: controls-start / controls-end;
    grid-row: top / segment-details-top;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }

    @media (max-width: 1452px) {
        padding: 8px 8px 8px 8px;
    }
`;

export default ControlPanel;
